<style src="./ParkingMap.scss" lang="scss"></style>
<template>
  <div>
    <l-map class="mapcontainer" :zoom="15" :center="center">
      <l-tile-layer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution="&copy; OpenStreetMap contributors"
      />
      <l-marker
        v-for="(m, index) in markers"
        :key="index"
        :lat-lng="m.position"
      >
        <l-popup>
          <div class="infowindowcontent">
            <h5>{{ m.parkName }}</h5>
            <h4>Quantidade de vagas: {{ m.parkingSpaceCount }}</h4>
          </div>
        </l-popup>
      </l-marker>
    </l-map>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LPopup } from '@vue-leaflet/vue-leaflet';

export default {
  name: 'ParkingMap',
  components: { LMap, LTileLayer, LMarker, LPopup },
  data: () => ({
    center: [-22.36416, -42.3133184],
    markers: [],
  }),
  mounted() {
    this.loadMarkers();
  },
  methods: {
    async loadMarkers() {
      const parkings = await this.$store.dispatch('PARKING/GetParkList');
      this.markers = parkings.map((parking) => ({
        position: [
          parking.pathPolygon.coordinates[0],
          parking.pathPolygon.coordinates[1],
        ],
        parkingSpaceCount: parking.parkingSpaceCount,
        parkName: parking.parkName,
      }));
    },
  },
};
</script>
